
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/understanding-different-face-shapes",
      function () {
        return require("private-next-pages/blog/understanding-different-face-shapes.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/understanding-different-face-shapes"])
      });
    }
  